import PuttersRecommendation from './PuttersRecommendation';

export default PuttersRecommendation;
